import React from "react";
import { motion } from "framer-motion";
import { MemoryRouter } from "react-router-dom";
import styles from "./Billingai.module.scss";

// --- Centralized Inline SVGs ---
const Icons = {
  Check: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
  ),
  ArrowRight: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M5 12h14M12 5l7 7-7 7"></path>
    </svg>
  ),
  Box: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
      <line x1="12" y1="22.08" x2="12" y2="12"></line>
    </svg>
  ),
  Settings: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  ),
  Eye: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  ),
  Chart: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <line x1="18" y1="20" x2="18" y2="10"></line>
      <line x1="12" y1="20" x2="12" y2="4"></line>
      <line x1="6" y1="20" x2="6" y2="14"></line>
    </svg>
  ),
  FileText: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  Pen: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 20h9"></path>
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
    </svg>
  ),
  Mail: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  ),
  Cloud: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),
  Infinity: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M18 6A6 6 0 0 1 18 18c-3.1 0-5.2-3.8-6-5.8S9.1 6 6 6a6 6 0 0 0 0 12c3.1 0 5.2-3.8 6-5.8S14.9 6 18 6z"></path>
    </svg>
  ),
  Refresh: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="23 4 23 10 17 10"></polyline>
      <polyline points="1 20 1 14 7 14"></polyline>
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
    </svg>
  ),
  Hash: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <line x1="4" y1="9" x2="20" y2="9"></line>
      <line x1="4" y1="15" x2="20" y2="15"></line>
      <line x1="10" y1="3" x2="8" y2="21"></line>
      <line x1="16" y1="3" x2="14" y2="21"></line>
    </svg>
  ),
  ClipboardList: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
      <line x1="12" y1="11" x2="16" y2="11"></line>
      <line x1="12" y1="16" x2="16" y2="16"></line>
      <line x1="8" y1="11" x2="8.01" y2="11"></line>
      <line x1="8" y1="16" x2="8.01" y2="16"></line>
    </svg>
  ),
  Bank: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polygon points="12 2 2 7 22 7 12 2"></polygon>
      <polyline points="2 17 22 17"></polyline>
      <polyline points="2 22 22 22"></polyline>
      <line x1="6" y1="17" x2="6" y2="7"></line>
      <line x1="10" y1="17" x2="10" y2="7"></line>
      <line x1="14" y1="17" x2="14" y2="7"></line>
      <line x1="18" y1="17" x2="18" y2="7"></line>
    </svg>
  ),
  Building: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
      <line x1="9" y1="22" x2="9" y2="22"></line>
      <line x1="15" y1="22" x2="15" y2="22"></line>
      <line x1="9" y1="6" x2="9" y2="6"></line>
      <line x1="15" y1="6" x2="15" y2="6"></line>
      <line x1="9" y1="10" x2="9" y2="10"></line>
      <line x1="15" y1="10" x2="15" y2="10"></line>
      <line x1="9" y1="14" x2="9" y2="14"></line>
      <line x1="15" y1="14" x2="15" y2="14"></line>
      <line x1="9" y1="18" x2="9" y2="18"></line>
      <line x1="15" y1="18" x2="15" y2="18"></line>
    </svg>
  ),
  Shield: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  XCircle: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>
  ),
  Zap: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    </svg>
  ),
  CreditCard: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  ),
  TrendingUp: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
};

// --- Animations ---
const parentVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const childVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

// --- Custom Billing AI Hero Art ---
const BillingHeroArt = () => (
  <div className="product-hero-art" aria-hidden>
    <div
      className="product-hero-art-glow"
      style={{
        background:
          "radial-gradient(ellipse 70% 60% at 50% 40%, rgba(79, 70, 229, 0.25) 0%, transparent 70%)",
      }}
    />
    <svg
      className="product-hero-svg"
      viewBox="0 0 440 380"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="hero-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="pipe-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4f46e5" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.2" />
        </linearGradient>
      </defs>

      {/* Grid Background */}
      <pattern
        id="grid-billing"
        width="30"
        height="30"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="2" cy="2" r="1" fill="rgba(255,255,255,0.1)" />
      </pattern>
      <rect width="100%" height="100%" fill="url(#grid-billing)" />

      {/* Data Pipeline Lines */}
      <path
        d="M 60 120 L 160 180 L 260 180 L 360 120"
        stroke="url(#pipe-grad)"
        strokeWidth="3"
        strokeDasharray="6 6"
        className="anim-dash"
      />
      <path
        d="M 60 260 L 160 200 L 260 200 L 360 260"
        stroke="url(#pipe-grad)"
        strokeWidth="3"
        strokeDasharray="6 6"
        className="anim-dash"
        style={{ animationDirection: "reverse" }}
      />

      {/* Input Node (Excel/Data) */}
      <g className="anim-float" style={{ animationDelay: "0.1s" }}>
        <rect
          x="40"
          y="110"
          width="50"
          height="40"
          rx="8"
          fill="rgba(79, 70, 229, 0.15)"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
        <text x="50" y="135" fill="#a5b4fc" fontSize="12" fontWeight="bold">
          XLSX
        </text>
      </g>

      <g className="anim-float" style={{ animationDelay: "0.3s" }}>
        <rect
          x="40"
          y="240"
          width="50"
          height="40"
          rx="8"
          fill="rgba(79, 70, 229, 0.15)"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
        <text x="50" y="265" fill="#a5b4fc" fontSize="12" fontWeight="bold">
          DATA
        </text>
      </g>

      {/* Central Processing Core (Engine) */}
      <g className="anim-pulse-box">
        <rect
          x="160"
          y="140"
          width="100"
          height="100"
          rx="16"
          fill="rgba(79, 70, 229, 0.15)"
          stroke="#4f46e5"
          strokeWidth="2"
          filter="url(#hero-glow)"
        />
        <circle cx="210" cy="190" r="24" fill="rgba(79, 70, 229, 0.3)" />
        <path
          d="M200 190 A10 10 0 1 1 220 190 A10 10 0 1 1 200 190"
          stroke="#818cf8"
          strokeWidth="3"
          className="anim-spin-slow"
          style={{ transformOrigin: "210px 190px" }}
        />
        <text
          x="180"
          y="130"
          fill="#818cf8"
          fontSize="10"
          fontWeight="bold"
          letterSpacing="1"
        >
          RULE ENGINE
        </text>
      </g>

      {/* Output Nodes (PDF / eSign) */}
      <g className="anim-float" style={{ animationDelay: "0.5s" }}>
        <rect
          x="330"
          y="100"
          width="60"
          height="40"
          rx="8"
          fill="rgba(79, 70, 229, 0.15)"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
        <text x="345" y="125" fill="#a5b4fc" fontSize="12" fontWeight="bold">
          PDF
        </text>
        <circle cx="390" cy="100" r="6" fill="#4f46e5" />
      </g>

      <g className="anim-float" style={{ animationDelay: "0.7s" }}>
        <rect
          x="330"
          y="240"
          width="60"
          height="40"
          rx="8"
          fill="rgba(79, 70, 229, 0.15)"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
        <text x="342" y="265" fill="#a5b4fc" fontSize="12" fontWeight="bold">
          eSign
        </text>
        <circle cx="390" cy="240" r="6" fill="#4f46e5" />
      </g>

      {/* Floating Status Badges */}
      <rect
        x="180"
        y="255"
        width="60"
        height="20"
        rx="10"
        fill="#0f172a"
        stroke="#818cf8"
        strokeWidth="1"
        className="anim-float"
        style={{ animationDelay: "0.8s" }}
      />
      <text x="188" y="269" fill="#818cf8" fontSize="9" fontWeight="bold">
        v3 Revision
      </text>
    </svg>
  </div>
);

const BillingAI = () => {
  return (
    <>
      <div className="product-page">
        {/* 1. HERO SECTION */}
        <section className="product-hero-dark">
          <div className="product-hero-mesh" />
          <div className="product-hero-glow-1" />
          <div className="product-hero-glow-2" />

          <div className="sec-container">
            <div className="product-hero-row">
              <motion.div
                className="product-hero-inner"
                variants={parentVariants}
                initial="hidden"
                animate="show"
              >
                <motion.div
                  className="product-eyebrow"
                  variants={childVariants}
                >
                  <span className="product-eyebrow-dot" /> Invoice Lifecycle
                  Platform
                </motion.div>
                <motion.h1 className="product-h1" variants={childVariants}>
                  Automate, Control & Audit Your Entire <br />
                  <span className="product-text-gradient">
                    Invoice Lifecycle
                  </span>
                </motion.h1>
                <motion.p className="product-lead" variants={childVariants}>
                  Generate, revise, track, and deliver invoices at scale with
                  built-in compliance, audit trails, and intelligent automation.
                </motion.p>
                <motion.div
                  className="product-cta-group"
                  variants={childVariants}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-light"
                    style={{ color: "#0f172a" }}
                  >
                    Book Demo <Icons.ArrowRight />
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                  >
                    Try Sandbox API
                  </a> */}
                </motion.div>
                <motion.div
                  variants={childVariants}
                  style={{
                    marginTop: "3.2rem",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "1.2rem",
                    padding: "1.2rem 2.4rem",
                    borderRadius: "1.6rem",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <Icons.Check
                    style={{ color: "#4f46e5", fontSize: "1.8rem" }}
                  />
                  <span
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: 600,
                      color: "rgba(255,255,255,0.8)",
                    }}
                  >
                    Process{" "}
                    <span style={{ color: "#fff" }}>5,000+ invoices</span> in a
                    single batch
                  </span>
                </motion.div>
              </motion.div>

              <motion.div
                variants={parentVariants}
                initial="hidden"
                animate="show"
                style={{ flex: 1, width: "100%" }}
              >
                <BillingHeroArt />
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. PROBLEM SECTION */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span
                className="product-section-eyebrow"
                style={{
                  backgroundColor: "rgba(239, 68, 68, 0.1)",
                  color: "#ef4444",
                  borderColor: "rgba(239, 68, 68, 0.2)",
                }}
              >
                The Problem
              </span>
              <h2 className="gen-h2">
                Still Creating Invoices Manually in Excel?
              </h2>
              <p className="gen-h2-sub">
                Manual billing is slow, error-prone, and impossible to audit.
                There's a better way.
              </p>
            </motion.div>

            <motion.div
              className={styles["product-problem-container"]}
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className={styles["product-problem-card"]}
                variants={childVariants}
              >
                <div className={`${styles["product-problem-head"]} before`}>
                  <Icons.XCircle /> Before
                </div>
                <ul className={styles["product-problem-list"]}>
                  <li className={`${styles["product-problem-row"]} before-row`}>
                    <Icons.XCircle /> Excel chaos & manual grouping
                  </li>
                  <li className={`${styles["product-problem-row"]} before-row`}>
                    <Icons.XCircle /> Billing errors with no preview
                  </li>
                  <li className={`${styles["product-problem-row"]} before-row`}>
                    <Icons.XCircle /> No audit trail or version control
                  </li>
                  <li className={`${styles["product-problem-row"]} before-row`}>
                    <Icons.XCircle /> Struggling with invoice revisions
                  </li>
                  <li className={`${styles["product-problem-row"]} before-row`}>
                    <Icons.XCircle /> Errors in billing reconciliation
                  </li>
                </ul>
              </motion.div>
              <motion.div
                className={styles["product-problem-card"]}
                variants={childVariants}
                style={{ borderColor: "#86efac" }}
              >
                <div className={`${styles["product-problem-head"]} after`}>
                  <Icons.Check /> After
                </div>
                <ul className={styles["product-problem-list"]}>
                  <li className={`${styles["product-problem-row"]} after-row`}>
                    <Icons.Check /> Automated billing with smart grouping
                  </li>
                  <li className={`${styles["product-problem-row"]} after-row`}>
                    <Icons.Check /> Zero errors — preview before generation
                  </li>
                  <li className={`${styles["product-problem-row"]} after-row`}>
                    <Icons.Check /> Full traceability & version history
                  </li>
                  <li className={`${styles["product-problem-row"]} after-row`}>
                    <Icons.Check /> Revise invoices without breaking history
                  </li>
                  <li className={`${styles["product-problem-row"]} after-row`}>
                    <Icons.Check /> Audit-ready financial operations
                  </li>
                </ul>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 3. CORE FEATURES */}
        <section className="product-section" id="features">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Core Features</span>
              <h2 className="gen-h2">Everything Your Billing Team Needs</h2>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Box />
                </div>
                <h3 className="product-card-title">
                  Automated Invoice Generation
                </h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  Upload Excel &rarr; Generate 1,000+ invoices instantly.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> State, Branch, Cluster grouping
                  </li>
                  <li>
                    <Icons.ArrowRight /> PAN India support
                  </li>
                  <li>
                    <Icons.ArrowRight /> Smart rule engine for pricing
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Settings />
                </div>
                <h3 className="product-card-title">Smart Rule Engine</h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  Dynamic configuration with override hierarchy.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> Client, State, Branch level rules
                  </li>
                  <li>
                    <Icons.ArrowRight /> Product / Case Type overrides
                  </li>
                  <li>
                    <Icons.ArrowRight /> Zero manual intervention
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Eye />
                </div>
                <h3 className="product-card-title">Invoice Preview Engine</h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  Preview invoices before final generation. Reduces billing
                  errors drastically.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> Shows grouping logic
                  </li>
                  <li>
                    <Icons.ArrowRight /> Rejection reasons & eligibility
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Chart />
                </div>
                <h3 className="product-card-title">Annexure Generation</h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  Auto-generated detailed Excel annexures with custom client
                  columns.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> Fully configurable structure
                  </li>
                  <li>
                    <Icons.ArrowRight /> Client-specific column mapping
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.FileText />
                </div>
                <h3 className="product-card-title">PDF Generation Engine</h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  Template-driven invoice generation with dynamic payload-based
                  rendering.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> Branding & client layouts
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Pen />
                </div>
                <h3 className="product-card-title">eSign Integration</h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  Integrated with remote signing APIs. No manual signing
                  required.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> Sign invoices directly from system
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Mail />
                </div>
                <h3 className="product-card-title">Email Delivery Engine</h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  Send invoices directly via email. Powered by scalable email
                  infra.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> Multiple recipients & CC list
                  </li>
                  <li>
                    <Icons.ArrowRight /> PDF + Excel attachments
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Cloud />
                </div>
                <h3 className="product-card-title">S3-Based Storage</h3>
                <p
                  className="product-card-desc"
                  style={{ marginBottom: "1.6rem" }}
                >
                  All documents stored on AWS S3. Secure access via pre-signed
                  URLs.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ marginTop: "auto" }}
                >
                  <li>
                    <Icons.ArrowRight /> No local storage dependency
                  </li>
                </ul>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 4. REVISION ENGINE (Dark Special Section) */}
        <section className={styles["product-special-dark"]}>
          <div className={styles["product-special-ambient"]} />
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span
                className="product-section-eyebrow"
                style={{
                  background: "rgba(79, 70, 229, 0.2)",
                  color: "#a5b4fc",
                  borderColor: "rgba(79, 70, 229, 0.3)",
                }}
              >
                Revision Engine — Your Biggest USP
              </span>
              <h2 className="gen-h2">
                Enterprise Grade
                <br />
                Invoice Revision System
              </h2>
              <p className="gen-h2-sub">
                Unlimited revisions with snapshot-based versioning and full
                audit trail — rare in market.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className={styles["product-special-card"]}
                variants={childVariants}
              >
                <div className={styles["product-special-icon"]}>
                  <Icons.Infinity />
                </div>
                <h4 className={styles["product-special-title"]}>Unlimited Revisions</h4>
                <p className={styles["product-special-desc"]}>
                  Edit any field — amount, address, tax details, items.
                  Recalculate taxes automatically.
                </p>
              </motion.div>
              <motion.div
                className={styles["product-special-card"]}
                variants={childVariants}
              >
                <div className={styles["product-special-icon"]}>
                  <Icons.Refresh />
                </div>
                <h4 className={styles["product-special-title"]}>Version Control</h4>
                <p className={styles["product-special-desc"]}>
                  Each revision creates a new version. Old invoice &rarr;
                  SUPERSEDED. New invoice &rarr; ACTIVE.
                </p>
              </motion.div>
              <motion.div
                className={styles["product-special-card"]}
                variants={childVariants}
              >
                <div className={styles["product-special-icon"]}>
                  <Icons.Hash />
                </div>
                <h4 className={styles["product-special-title"]}>Controlled Numbering</h4>
                <p className={styles["product-special-desc"]}>
                  Keep same invoice number or generate new sequence. Prevents
                  duplication & audit issues.
                </p>
              </motion.div>
              <motion.div
                className={styles["product-special-card"]}
                variants={childVariants}
              >
                <div className={styles["product-special-icon"]}>
                  <Icons.ClipboardList />
                </div>
                <h4 className={styles["product-special-title"]}>Audit Trail</h4>
                <p className={styles["product-special-desc"]}>
                  Track who revised, when it was revised, and what changed —
                  complete traceability.
                </p>
              </motion.div>
            </motion.div>

            <motion.div
              className={styles["product-regen-banner"]}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <div className={styles["product-regen-text"]}>
                <h4>After Every Revision — Auto Regenerate</h4>
                <p>
                  PDF Invoice & Annexure Excel are automatically regenerated on
                  each revision.
                </p>
              </div>
              <div className={styles["product-regen-tags"]}>
                <span className={styles["product-regen-tag"]}>PDF Regenerated</span>
                <span className={styles["product-regen-tag"]}>Annexure Regenerated</span>
              </div>
            </motion.div>
          </div>
        </section>

        {/* 5. SECURITY & CONFIGURATION (Split) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <div className={styles["product-split-layout"]}>
              {/* Security */}
              <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={parentVariants}
              >
                <motion.span
                  className="product-section-eyebrow"
                  variants={childVariants}
                >
                  Security & Access Control
                </motion.span>
                <motion.h2
                  className="gen-h2"
                  style={{ fontSize: "3.6rem" }}
                  variants={childVariants}
                >
                  Enterprise-Grade Security Built In
                </motion.h2>
                <motion.p
                  className="gen-h2-sub"
                  style={{ marginBottom: "3.2rem" }}
                  variants={childVariants}
                >
                  API-first, stateless architecture with JWT-based
                  authentication and complete audit logging.
                </motion.p>

                <motion.div
                  variants={childVariants}
                  style={{ marginBottom: "3.2rem" }}
                >
                  <h4
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: 700,
                      color: "#0f172a",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      margin: "0 0 1.6rem 0",
                    }}
                  >
                    Role-Based Access Control (RBAC)
                  </h4>
                  <div className={styles["product-rbac-pills"]}>
                    <span className={styles["product-rbac-pill"]}>
                      <Icons.Shield style={{ color: "#4f46e5" }} /> ADMIN
                    </span>
                    <span className={styles["product-rbac-pill"]}>
                      <Icons.CreditCard style={{ color: "#4f46e5" }} /> ACCOUNTS
                    </span>
                    <span className={styles["product-rbac-pill"]}>
                      <Icons.Settings style={{ color: "#4f46e5" }} />{" "}
                      CONFIG_MANAGER
                    </span>
                    <span className={styles["product-rbac-pill"]}>
                      <Icons.Eye style={{ color: "#4f46e5" }} /> VIEWER
                    </span>
                  </div>
                </motion.div>

                <motion.div
                  className="product-card"
                  variants={childVariants}
                  style={{ padding: "2.4rem" }}
                >
                  <h4
                    className="product-card-title"
                    style={{ fontSize: "1.6rem" }}
                  >
                    Audit Logging Tracks
                  </h4>
                  <ul className="product-feature-list" style={{ margin: 0 }}>
                    <li>
                      <Icons.ArrowRight /> Invoice revisions
                    </li>
                    <li>
                      <Icons.ArrowRight /> Config changes
                    </li>
                    <li>
                      <Icons.ArrowRight /> User actions
                    </li>
                  </ul>
                </motion.div>
              </motion.div>

              {/* Configuration */}
              <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={parentVariants}
              >
                <motion.span
                  className="product-section-eyebrow"
                  variants={childVariants}
                >
                  Configuration Management
                </motion.span>
                <motion.h2
                  className="gen-h2"
                  style={{ fontSize: "3.6rem" }}
                  variants={childVariants}
                >
                  Flexible Multi-Org Configuration
                </motion.h2>
                <motion.p
                  className="gen-h2-sub"
                  style={{ marginBottom: "3.2rem" }}
                  variants={childVariants}
                >
                  Support multiple billing entities with dynamic bank details &
                  GST handling.
                </motion.p>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.6rem",
                  }}
                >
                  <motion.div
                    className="product-card"
                    variants={childVariants}
                    style={{ padding: "2.4rem" }}
                  >
                    <h4
                      className="product-card-title"
                      style={{ fontSize: "1.6rem", marginBottom: "0.8rem" }}
                    >
                      Client Configuration Engine
                    </h4>
                    <p className="product-card-desc">
                      Manage GST, PAN, Address, Pricing rules with override at
                      multiple levels.
                    </p>
                  </motion.div>
                  <motion.div
                    className="product-card"
                    variants={childVariants}
                    style={{ padding: "2.4rem" }}
                  >
                    <h4
                      className="product-card-title"
                      style={{ fontSize: "1.6rem", marginBottom: "0.8rem" }}
                    >
                      Multi-Organization Support
                    </h4>
                    <p className="product-card-desc">
                      Support multiple billing entities. Dynamic bank details &
                      GST handling per org.
                    </p>
                  </motion.div>
                  <motion.div
                    className="product-card"
                    variants={childVariants}
                    style={{ padding: "2.4rem" }}
                  >
                    <h4
                      className="product-card-title"
                      style={{ fontSize: "1.6rem", marginBottom: "0.8rem" }}
                    >
                      JWT-Based Authentication
                    </h4>
                    <p className="product-card-desc">
                      Secure token-based login. Stateless architecture.
                      API-first design.
                    </p>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 6. BUSINESS BENEFITS */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Business Benefits</span>
              <h2 className="gen-h2">Measurable Impact on Your Operations</h2>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-scale"
                variants={childVariants}
              >
                <div
                  style={{
                    fontSize: "3.6rem",
                    fontWeight: 800,
                    color: "#4f46e5",
                    marginBottom: "1.6rem",
                  }}
                >
                  90%
                </div>
                <h3 className="product-card-title">Reduce Manual Work</h3>
                <p className="product-card-desc">
                  No manual Excel processing. No manual invoice creation.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-scale"
                variants={childVariants}
              >
                <div
                  style={{
                    fontSize: "3.6rem",
                    fontWeight: 800,
                    color: "#4f46e5",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.Zap />
                </div>
                <h3 className="product-card-title">Faster Billing Cycles</h3>
                <p className="product-card-desc">
                  Generate 1,000+ invoices in minutes, not days.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-scale"
                variants={childVariants}
              >
                <div
                  style={{
                    fontSize: "3.6rem",
                    fontWeight: 800,
                    color: "#4f46e5",
                    marginBottom: "1.6rem",
                  }}
                >
                  0
                </div>
                <h3 className="product-card-title">Zero Billing Errors</h3>
                <p className="product-card-desc">
                  Preview + rule engine ensures accuracy before generation.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-scale"
                variants={childVariants}
              >
                <div
                  style={{
                    fontSize: "3.6rem",
                    fontWeight: 800,
                    color: "#4f46e5",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.FileText />
                </div>
                <h3 className="product-card-title">Audit & Compliance Ready</h3>
                <p className="product-card-desc">
                  Full traceability, version history, no data loss.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-scale"
                variants={childVariants}
              >
                <div
                  style={{
                    fontSize: "3.6rem",
                    fontWeight: 800,
                    color: "#4f46e5",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.Refresh />
                </div>
                <h3 className="product-card-title">Easy Corrections</h3>
                <p className="product-card-desc">
                  Revise invoices without breaking history or audit trail.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-scale"
                variants={childVariants}
              >
                <div
                  style={{
                    fontSize: "3.6rem",
                    fontWeight: 800,
                    color: "#4f46e5",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.Chart />
                </div>
                <h3 className="product-card-title">Scalable Architecture</h3>
                <p className="product-card-desc">
                  Microservices ready. Cloud-native (AWS). Built for scale.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 7. TARGET AUDIENCE */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Ideal For</span>
              <h2 className="gen-h2">Who Benefits Most</h2>
            </motion.div>

            <motion.div
              className={styles["product-audience-grid"]}
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className={styles["product-audience-card"]}
                variants={childVariants}
              >
                <div className={styles["product-audience-icon"]}>
                  <Icons.Bank />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Banks & NBFCs
                </h3>
                <p className="product-card-desc">
                  High-volume verification billing.
                </p>
              </motion.div>
              <motion.div
                className={styles["product-audience-card"]}
                variants={childVariants}
              >
                <div className={styles["product-audience-icon"]}>
                  <Icons.Building />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Fintech Companies
                </h3>
                <p className="product-card-desc">API-based billing systems.</p>
              </motion.div>
              <motion.div
                className={styles["product-audience-card"]}
                variants={childVariants}
              >
                <div className={styles["product-audience-icon"]}>
                  <Icons.Chart />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Ops-Heavy Businesses
                </h3>
                <p className="product-card-desc">
                  Field verification, CPV, legal, etc.
                </p>
              </motion.div>
              <motion.div
                className={styles["product-audience-card"]}
                variants={childVariants}
              >
                <div className={styles["product-audience-icon"]}>
                  <Icons.FileText />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Enterprises
                </h3>
                <p className="product-card-desc">
                  Multi-client, multi-region billing.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 8. DIFFERENTIATORS */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              style={{ marginBottom: "4rem" }}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">
                What Makes Us Different
              </span>
              <h2 className="gen-h2">
                Not Just Invoicing —<br />
                Full Lifecycle Management
              </h2>
            </motion.div>

            <motion.div
              className={styles["product-diff-pills"]}
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.span
                className={styles["product-diff-pill"]}
                variants={childVariants}
              >
                <Icons.Zap /> Full lifecycle management
              </motion.span>
              <motion.span
                className={styles["product-diff-pill"]}
                variants={childVariants}
              >
                <Icons.Refresh /> Built-in revision engine
              </motion.span>
              <motion.span
                className={styles["product-diff-pill"]}
                variants={childVariants}
              >
                <Icons.Settings /> Intelligent rule-based billing
              </motion.span>
              <motion.span
                className={styles["product-diff-pill"]}
                variants={childVariants}
              >
                <Icons.Eye /> Preview before billing
              </motion.span>
              <motion.span
                className={styles["product-diff-pill"]}
                variants={childVariants}
              >
                <Icons.FileText /> Audit-ready architecture
              </motion.span>
              <motion.span
                className={styles["product-diff-pill"]}
                variants={childVariants}
              >
                <Icons.Cloud /> Cloud-native & scalable
              </motion.span>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              style={{
                textAlign: "center",
                maxWidth: "60rem",
                margin: "0 auto",
                borderLeft: "4px solid #4f46e5",
                paddingLeft: "2.4rem",
              }}
            >
              <p
                style={{
                  fontSize: "1.8rem",
                  fontStyle: "italic",
                  fontWeight: 600,
                  color: "#334155",
                  margin: 0,
                  lineHeight: 1.6,
                }}
              >
                "An intelligent, audit-ready invoice lifecycle platform built
                for high-volume financial operations."
              </p>
            </motion.div>
          </div>
        </section>

        {/* 9. FINAL CTA (DARK) */}
        <section className="product-dark-cta">
          <div className={styles["product-special-ambient"]} />
          <div className="sec-container">
            <div
              className="product-cta-grid"
              style={{ gridTemplateColumns: "1fr", textAlign: "center" }}
            >
              <div style={{ maxWidth: "80rem", margin: "0 auto" }}>
                <span
                  className="product-eyebrow"
                  style={{
                    backgroundColor: "rgba(79, 70, 229, 0.1)",
                    color: "#a5b4fc",
                    borderColor: "rgba(79, 70, 229, 0.3)",
                  }}
                >
                  Get Started
                </span>
                <h2 className="product-h1" style={{ fontSize: "4.8rem" }}>
                  Ready to Automate Your
                  <br />
                  Invoice Lifecycle?
                </h2>
                <p className="product-lead" style={{ marginBottom: "4rem" }}>
                  Book a demo, get started, or try our Sandbox API today.
                </p>
                <div
                  className="product-cta-group"
                  style={{ justifyContent: "center" }}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-light"
                    style={{ padding: "1.6rem 3.2rem", color: "#0f172a" }}
                  >
                    Book Demo <Icons.ArrowRight />
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Try Sandbox API
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BillingAI;
